export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-rewind-ten-f78e12ffead5da9784c8ea5319009ab9.svg";